import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {RequestReportVariable, ResponseReportVariableList, ResponseVariableList} from './reportvariable-setting.dto';

@Injectable()
export class ReportvariableSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'reportvariable-setting';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public reportvariablelist(): Observable<ResponseReportVariableList[]> {
    const method: string = 'GET';
    const func: string = 'reportvariablelist';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReportVariableList[]>(method, url, params, urlParams, body);
  }

  public reportvariablelistdetail(): Observable<ResponseVariableList[]> {
    const method: string = 'GET';
    const func: string = 'reportvariablelistdetail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseVariableList[]>(method, url, params, urlParams, body);
  }

  public reportvariableupdate(payload: RequestReportVariable[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'reportvariableupdate';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/reportvariable-setting.api.ts